module.exports = __webpack_public_path__ + "img/center_focus_weak.87aaa063.svg";